import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TixCardModule } from '../card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TixInputModule } from '../input';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TixCardModule,
    TixInputModule,
    MatFormFieldModule,
    MatInputModule
  ],
  exports: []
})
export class TixDomainModule {}
